'use strict'

const CREW_COLORS = [
  '#2196F3', '#4CAF50', '#FF9800', '#9C27B0', '#00BCD4',
  '#F44336', '#795548', '#607D8B', '#E91E63', '#3F51B5',
  '#8BC34A', '#FF5722', '#009688', '#CDDC39', '#673AB7'
]

export function getCrewColor (crewId, crewIds) {
  const index = crewIds.indexOf(crewId)
  if (index < 0) return '#9E9E9E'
  return CREW_COLORS[index % CREW_COLORS.length]
}

export function getRouteColor (routeId, routeIds) {
  const index = (routeIds || []).indexOf(routeId)
  if (index < 0) return '#9E9E9E'
  return CREW_COLORS[index % CREW_COLORS.length]
}

export default CREW_COLORS
